import { retainedState, useRetainedState } from 'shared/src/hooks/retainedState';

/**
 * PostGoodsActionBottomSheet 가 떠있는지 여부.
 * GoodsDetail.page 의 useHandleBackPressed 가 이 값을 보고 back press 를
 * 바텀시트(ui-kit BottomSheetContainer 의 BackHandler) 로 propagation 시킬지 결정한다.
 *
 * 배경: BackHandler 는 LIFO + React effect children-first 라 GoodsDetail-A 의
 * useHandleBackPressed listener 가 stack top 차지. A 의 콜백이 항상 true 반환하면
 * propagation 차단 → 바텀시트 listener 호출 안 됨.
 */
const postGoodsActionBottomSheetOpenState = retainedState(false);

export const useIsPostGoodsActionBottomSheetOpen = () =>
  useRetainedState(postGoodsActionBottomSheetOpenState);
